import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=77a4396a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77a4396a')) {
      api.createRecord('77a4396a', component.options)
    } else {
      api.reload('77a4396a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=77a4396a&", function () {
      api.rerender('77a4396a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eS3966fHKd0o/JS/comp/childrenage.vue"
export default component.exports